import { isLocal } from '@Constants/BuildInfo';
import { REAXYS_ROOT_DOMAINS } from '@Constants';
import { FEATURES } from '@Constants/rx-ui/constants';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { generateTraceHeaders } from '@Services/CorrelationId';
import * as AuthHelper from '@Services/Auth/AuthHelper';

const isReaxysDomain = () => {
  if (isLocal()) {
    return true; // In local development, we assume it's a Reaxys domain
  }
  return REAXYS_ROOT_DOMAINS.some((domain) => window.location.hostname.endsWith(domain));
};

export function isTexelAccessFenceEnabled() {
  return AuthHelper.isFeatureEnabled(FEATURES.texel_access_enabled);
}

export function isTexelAccessEnabled() {
  return isTexelAccessFenceEnabled() && isReaxysDomain() && !AuthHelper.isAnonymousUser();
}

export async function redirectToTexel() {
  const accessToken = AuthHelper.getAccessToken();
  // Using fetch here instead of MessageBroker.send to get the redirect URL,
  // because browser follows redirect seamlessly, so we're getting responsr not from /linkout but from destination redirect URL.
  const response = await fetch(RequestUrls.texelLinkout.url, {
    method: RequestUrls.texelLinkout.method,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...generateTraceHeaders(),
    },
  });

  if (!response.redirected) {
    return Logger.reject('Texel redirect - linkout is not redirected', response);
  }

  return window.open(response.url, '_blank');
}
